import type { StateObject } from "../redux/types"
import type { ObjectOfVersions, OperationsState } from "./reducer"

export const getOperationsStateObject = (state: StateObject): OperationsState => state.operations

export const getProcessingState = (state: StateObject): string => getOperationsStateObject(state).state

export const areOperationsBeingProcessed = (state: StateObject): boolean => getProcessingState(state) === "processing"

export const getVersionObject = (state: StateObject): ObjectOfVersions => getOperationsStateObject(state).versions

export const getVersionById = (state: StateObject, id: string): number => {
    return getVersionObject(state)[id] || 0
}
